export default ($axios, baseUrl) => ({
  track(pcode) {
    let query = ''
    if (pcode !== undefined && pcode !== null && pcode.length > 0) {
      query = '?pcode=' + pcode
    }
    return $axios.get(`${baseUrl}track/pcode` + query)
  },
})
